<template>
    <div>
        <v-row>
            <v-col cols="12">
                <div class="elevation-2 pa-4">
                    <div class="body-1 grey--text text--darken-3">
                        Breakeven
                    </div>
                    <v-row>
                        <v-col md="3" cols="12">
                            <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                                <img src="../assets/icons/cards/money-delivery.svg" alt="" width="64">
                                <div class="d-flex flex-column align-center">
                                    <span class="grey--text text--darken-2 body-2">Valor de compra</span>
                                    <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!purchasePrice ? '--' : formatterMoney.format(purchasePrice)}}</span>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="3" cols="12">
                            <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                                <img src="../assets/icons/cards/recepit.svg" alt="" width="64">
                                <div class="d-flex flex-column align-center">
                                    <span class="grey--text text--darken-2 body-2">Receita total líquida</span>
                                    <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!totalRevenue ? '--' : formatterMoney.format(totalRevenue)}}</span>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="6" cols="12">
                            <div class="elevation-2 white d-flex justify-space-around pa-4 align-center height-fluid"> 
                                <v-progress-linear
                                    v-model="pct_breakeven"
                                    color="#feab01"
                                    height="24"
                                ></v-progress-linear>
                                <span class="grey--text text--darken-3 subtitle-1 font-weight-bold ml-8 text-no-wrap">{{!pct_breakeven ? '--' : pct_breakeven + ' %'}}</span>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="elevation-2 pa-4">
                    <div class="body-1 grey--text text--darken-3">
                        Meta
                    </div>
                    <v-row>
                        <v-col md="3" cols="12">
                            <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                                <img src="../assets/icons/cards/viewers-compare-money.svg" alt="" width="64">
                                <div class="d-flex flex-column align-center">
                                    <span class="grey--text text--darken-2 body-2">Meta Estipulada</span>
                                    <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!stipulatedGoal ? '--' : formatterMoney.format(stipulatedGoal)}}</span>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="3" cols="12">
                            <div class="elevation-2 white d-flex justify-space-around pa-4 align-center">
                                <img src="../assets/icons/cards/recepit.svg" alt="" width="64">
                                <div class="d-flex flex-column align-center">
                                    <span class="grey--text text--darken-2 body-2">Receita</span>
                                    <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!revenue ? '--' : formatterMoney.format(revenue)}}</span>
                                </div>
                            </div>
                        </v-col>
                        <v-col md="6" cols="12">
                            <div class="elevation-2 white d-flex justify-space-around pa-4 align-center height-fluid">   
                                <v-progress-linear
                                    v-model="pct_meta"
                                    color="#feab01"
                                    height="24"
                                ></v-progress-linear>
                                <div class="grey--text text--darken-3 subtitle-1 font-weight-bold ml-8 text-no-wrap">{{!pct_meta ? '--' : pct_meta + ' %'}}</div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="elevation-2 pa-4">
                    <div class="body-1 grey--text text--darken-3 d-flex justify-space-between align-center">
                        <span>Variações</span>
                        <v-col cols="4">
                            <v-select
                                v-model="aggregationSelected"
                                :items="aggregation"
                                item-text="name"
                                item-value="value"
                                label="Periodicidade"
                                @change="getRevenueChange();getMonthViews();"
                            >
                            </v-select>
                        </v-col>
                    </div>
                    <v-row>
                        <v-col cols="12">
                            <div class="elevation-2 pa-4 size-card card-table">
                                Variação de receita líquida
                                <div v-if="loadingReavenue" class="d-flex height-fluid justify-center align-center">
                                    <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    size="72"
                                    ></v-progress-circular>
                                </div>
                                <template v-else>
                                    <GChart
                                        class="mt-2 card-percentage"
                                        type="LineChart"
                                        :data="chartDataItems.monthly_revenue_change"
                                        :options="chartOptionsLine"
                                        v-if="chartDataItems.monthly_revenue_change.length > 2"
                                        />
                                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                                        <img src="../assets/empty/empty-cms.svg" alt="">
                                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                            Não há dados a serem exibidos com este filtro!
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <div class="elevation-2 pa-4 size-card card-table">
                                Variação de visualizações
                                <div v-if="loadingViews" class="d-flex height-fluid justify-center align-center">
                                    <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    size="72"
                                    ></v-progress-circular>
                                </div>
                                <template v-else>
                                    <GChart
                                        class="mt-2 card-percentage"
                                        type="LineChart"
                                        :data="chartDataItems.monthly_view_variation"
                                        :options="chartOptionsLine"
                                        v-if="chartDataItems.monthly_view_variation.length > 2"
                                        />
                                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                                        <img src="../assets/empty/empty-cms.svg" alt="">
                                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                            Não há dados a serem exibidos com este filtro!
                                        </span>
                                    </div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
export default {
    components: {
        GChart
    },
    created() {
        this.getBreakeven();
        this.getGoal();
        this.getRevenueChange();
        this.getMonthViews();
    },
    props: {
        channel: {
            type: Number,
            required: true,
            default: null
        },
        dateIni: {
            type: String,
            required: true,
            default: null
        },
        dateEnd: {
            type: String,
            required: true,
            default: null
        }
    },
    data: () => ({
        formatterMoney: new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}),
        purchasePrice: '',
        totalRevenue: '',
        stipulatedGoal: '',
        revenue: '',
        pct_breakeven: 0,
        pct_meta: 0,
        aggregationSelected: 'day',
        aggregation: [
            {
                'name': 'Diário',
                'value': 'day'
            },
            {
                'name': 'Mensal',
                'value': 'month'
            }
        ],
        chartDataItems: {
            monthly_revenue_change: [],
            monthly_view_variation: [],
        },
        chartOptionsLine: {
            chartArea: {width:'90%'},
            legend: {position: 'bottom'},
        },
        loadingViews: true,
        loadingReavenue: true
    }),
    methods: {
        getBreakeven() {
            this.$http.get( '/channel/'+ this.channel +'/goal/breakeven?start_date='+this.dateIni)
            .then( ( res ) => {
                this.purchasePrice = res.data.price;
                this.totalRevenue = res.data.total_revenue;
                this.pct_breakeven = res.data.percentage;
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getGoal() {
            this.$http.get( '/channel/'+ this.channel +'/goal/month?start_date='+this.dateIni)
            .then( ( res ) => {
                this.stipulatedGoal = res.data.goal;
                this.revenue = res.data.total_revenue;
                this.pct_meta = res.data.percentage;
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            });
        },
        getRevenueChange() {
            this.$http.get( '/channel/'+ this.channel +'/goal/revenue?aggregation='+this.aggregationSelected+'&start_date='+this.dateIni)
            .then( ( res ) => {
                this.chartDataItems.monthly_revenue_change = res.data
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            }) .finally( () => {
                this.loadingReavenue = false;
            });
        },
        getMonthViews() {
            this.$http.get( '/channel/'+ this.channel +'/goal/views?aggregation='+this.aggregationSelected+'&start_date='+this.dateIni)
            .then( ( res ) => {
                this.chartDataItems.monthly_view_variation = res.data
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro na solicitação.',
                    type: 'error',
                    closeText: 'Fechar'
                },
                this.$emit( 'notification', this.notification );
            }) .finally( () => {
                this.loadingViews = false;
            } );
        }
    }
}
</script>

<style>
    .card-table {
        min-height: 400px;
    }
    .card-percentage {
        height: 400px;
    }
    .size-card {
        height: 100%;
    }
</style>